import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BenefitsDetail} from '../../../models/benefits.model';

@Component({
  selector: 'app-rent-info',
  templateUrl: './rent-info.component.html',
  styleUrls: ['./rent-info.component.scss']
})
export class RentInfoComponent implements OnInit {
  @Input() itemsCoreData: any;
  @Input() enableAvailability: boolean = true;
  @Input() enableEdit: boolean = true;
  @Input() enableDelete: boolean = true;
  @Input() hasIntro: boolean = false;
  @Input() isNewlifetimeRent: boolean = false;
  @Input() mantenienceSection;
  @Input() hasLink: boolean = false;
  @Input() showPlaceHolder: boolean = false;
  @Output() itemAvailability: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemCreate: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemEdit: EventEmitter<any> = new EventEmitter<any>();


  constructor() {
  }

  ngOnInit(): void {
  }

  sendItemAvailability(itemId: number): void {
    this.itemAvailability.emit(itemId);
  }

  sendItemCreate(): void {
    this.itemCreate.emit(true);
  }

  sendItemEdit(item: any): void {
    this.itemEdit.emit(item);
  }

  sendItemDelete(itemId: number) {
    this.itemDelete.emit(itemId);
  }
}
